import { type FC } from 'react'

import { BrandIconNowDelivery } from '@redteclab/brand-icons'

import { useGlobalConfigContext } from '../../../../global-config'
import {
  nowBasicCheckRespGetSlotForCountdown,
  nowBasicCheckRespIsEligibleOrMinimumValueNotReached,
} from '../../../../now'
import { TENANT } from '../../../../tenant'
import { useProductPageContext } from '../../productPageContext'

import { ProductBuyBoxNowInfoCountdown } from './ProductBuyBoxNowInfoCountdown/ProductBuyBoxNowInfoCountdown'
import { ProductBuyBoxNowInfoDay } from './ProductBuyBoxNowInfoDay/ProductBuyBoxNowInfoDay'
import { ProductBuyBoxNowInfoSeeDetailsButton } from './ProductBuyBoxNowInfoSeeDetailsButton/ProductBuyBoxNowInfoSeeDetailsButton'

export const ProductBuyBoxNowInfo: FC = () => {
  const { tenant } = useGlobalConfigContext()
  const { nowDetails, product } = useProductPageContext()

  const nowDetailsForProduct =
    nowDetails.nowDataPerProduct[product.upid]?.responseData

  if (
    !nowBasicCheckRespIsEligibleOrMinimumValueNotReached(nowDetailsForProduct)
  ) {
    return null
  }

  const countDownSlot =
    nowDetailsForProduct &&
    nowBasicCheckRespGetSlotForCountdown(nowDetailsForProduct)

  if (!countDownSlot) {
    return null
  }

  return tenant === TENANT.COM ? (
    <div className="mb-3 w-full rounded-3xl bg-light-primary-low p-4">
      <div className="flex">
        <div>
          <div className="mr-2.5 flex size-12 items-center justify-center rounded-full bg-light-primary-low">
            <BrandIconNowDelivery className="size-12 fill-dark-brand" />
          </div>
        </div>
        <div className="flex flex-col">
          <span className="text-s font-medium text-dark-primary-max">
            <ProductBuyBoxNowInfoDay nowSlot={countDownSlot} />
          </span>
          <span className="mt-1 text-xs text-dark-primary-strong">
            <ProductBuyBoxNowInfoCountdown nowSlot={countDownSlot} />
          </span>
        </div>
      </div>
    </div>
  ) : (
    <div className="w-full border-b border-dark-primary-min py-2.5">
      <ProductBuyBoxNowInfoDay nowSlot={countDownSlot} />
      <ProductBuyBoxNowInfoCountdown nowSlot={countDownSlot} />
      <ProductBuyBoxNowInfoSeeDetailsButton />
    </div>
  )
}
